import Inputmask from "inputmask";


var maskUsername = document.querySelectorAll(".m_username");
if(maskUsername){
    Inputmask({ mask: [ "999.999.999-99", "99.999.999/9999-99", "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@*{1,63}.*{1,63}[.*{1,63}][.*{1,63}]"], 
    greedy: false,
    definitions: {
      '*': {
        validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
        casing: "lower"
      }
    }
}).mask(maskUsername);
}


var maskTel = document.querySelectorAll(".m_tel");
if(maskTel){
    Inputmask({ mask: ["(99) 9999-9999", "(99) 99999-9999" ], greedy: false }).mask(maskTel);
}


var maskCel = document.querySelectorAll(".m_cel");
if(maskCel){
    Inputmask("(99) 99999-9999").mask(maskCel);
}


var maskCep = document.querySelectorAll(".m_cep");
if(maskCep){
    Inputmask("99999-999").mask(maskCep);
}


var maskCnpj = document.querySelectorAll(".m_cnpj");
if(maskCnpj){
    Inputmask("99.999.999/9999-99").mask(maskCnpj);
}



var maskCpf = document.querySelectorAll(".m_cpf");
if(maskCpf){
    Inputmask("999.999.999-99").mask(maskCpf);
}



var maskDate = document.querySelectorAll(".m_date");
if(maskDate){
    Inputmask("99/99/9999").mask(maskDate);
}



var maskDatetime = document.querySelectorAll(".m_datetime");
if(maskDatetime){
    Inputmask("99/99/9999 99:99").mask(maskDatetime);
}



var maskDatetimeFull = document.querySelectorAll(".m_datetimeFull");
if(maskDatetimeFull){
    Inputmask("99/99/9999 99:99:99").mask(maskDatetimeFull);
}



var maskMonthYear = document.querySelectorAll(".m_datetimeFull");
if(maskMonthYear){
    Inputmask("99/9999").mask(maskMonthYear);
}

